import * as React from 'react';

import { cn } from '../../utils/cn';

export function AlertDialogFooter({
    className,
    ...props
}: React.ComponentProps<'div'>) {
    return (
        <div
            data-slot="alert-dialog-footer"
            className={cn('flex flex-row justify-center gap-2', className)}
            {...props}
        />
    );
}
